module.exports = __webpack_public_path__ + "static/result-proud-20ca75dce580abc1374918c2de952b39.png";